<template>
  <project-detail-layout :tab="5">
    <div class="history-project-ctn">
      <div class="ptable_wrapper">
        <div class="btn_group">
          <button class="btn_img" type="button" @click="show = true">
            <img src="@/assets/icons/plus_his.svg" alt="xls_icon" />
          </button>
          <button class="confirm-button" type="submit">
            {{
              $t(
                "project_management.project_detail.button_title.add_contract_history"
              )
            }}
          </button>
        </div>
        <table class="table ptable">
          <thead class="ptable__thead">
            <tr>
              <th class="vertical_align">
                {{ $t("project_management.project_detail.table_column.no") }}
              </th>
              <th class="vertical_align">
                {{ $t("project_management.project_detail.table_column.date") }}
              </th>
              <th class="vertical_align">
                {{
                  $t(
                    "project_management.project_detail.table_column.quotation_documents"
                  )
                }}
              </th>
              <th class="vertical_align">
                {{
                  $t("project_management.project_detail.table_column.timesheet")
                }}
              </th>
              <th class="vertical_align">
                {{
                  $t(
                    "project_management.project_detail.table_column.manipulation"
                  )
                }}
              </th>
            </tr>
          </thead>
          <tbody class="ptable__tbody" v-for="(item, key) in historyContract" :key="key">
            <tr>
              <td>{{ key + 1 }}</td>
              <td>{{ item.date }}</td>
              <td class="quotation_documents">
                <div class="quotation_documents__group">
                  <img src="@/assets/icons/xls_icon.svg" alt="xls_icon" />
                  <span>{{ item.document }}</span>
                </div>
              </td>
              <td>{{ item.timeSheet }}MM</td>
              <td class="manipulation">
                <div class="manipulation__group">
                  <button>
                    <img
                      src="@/assets/icons/icon_edit_his.svg"
                      alt="pencil"
                      @click="show = true"
                    />
                  </button>
                  <button>
                    <img src="@/assets/icons/icon_delete_his.svg" alt="trash" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <b-modal
        class="b-modal"
        v-model="show"
        ref="modal"
        hide-footer
        title="Submit Your Name"
        centered
      >
        <template #modal-title>
          {{
            $t(
              "project_management.project_detail.button_title.add_contract_history"
            )
          }}
        </template>
        <ValidationObserver v-slot="{ handleSubmit }" ref="effortForm">
          <Form @submit.prevent="handleSubmit(onSubmit)">
            <div class="input-wrapper effort">
              <div class="label">
                {{ $t("project_management.project_detail.table_column.date") }}
                <span class="required">*</span>
              </div>
              <ValidationProvider
                v-slot="{ errors }"
                name="project_detail.project.date"
                rules="required"
              >
                <DatePicker
                  :clearable="false"
                  v-model="newContract.date"
                  :format="'DD/MM/YYYY'"
                />
                <div class="validation_error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="input-wrapper effort">
              <div class="label">
                {{
                  $t(
                    "project_management.project_detail.table_column.quotation_documents"
                  )
                }}
                <span class="required">*</span>
              </div>
              <ValidationProvider
                v-slot="{ validate, errors }"
                vid="file"
                rules="required"
                name="project_detail.project.timesheet"
              >
                <input
                  ref="fileFormCatSupOne"
                  type="file"
                  class="form-control-file"
                  id="fileXlsx"
                  accept=".xlsx, .xls, .csv"
                  style="display: none"
                  @change="onChangeFile($event) || validate($event)"
                />
                <label for="fileXlsx">
                  <img src="@/assets/icons/pdf_icon.svg" alt="pdf_icon" />
                  <span>
                    {{
                      $t(
                        "project_management.project_detail.button_title.choose_file"
                      )
                    }}
                  </span>
                </label>
                <!-- <span v-if="!isImage" class="error image required">
                  {{ errorFileMessage }}
                </span> -->
                <div class="validation_error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <div class="input-wrapper effort">
              <div class="label">
                {{
                  $t("project_management.project_detail.table_column.timesheet")
                }}
                <span class="required">*</span>
              </div>
              <ValidationProvider
                v-slot="{ errors }"
                name="project_detail.project.timesheet"
                rules="required"
              >
                <input type="text" v-model="newContract.timeSheet" />
                <div class="validation_error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <div class="btn_group">
              <button class="confirm-button" type="submit">
                {{ $t("project_management.kickoff.kickoff_button_submit") }}
              </button>
              <button @click="show = false" class="cancel-button" type="button">
                {{ $t("project_management.kickoff.kickoff_button_cancel") }}
              </button>
            </div>
          </Form>
        </ValidationObserver>
      </b-modal>
    </div>
  </project-detail-layout>
</template>
<script>
import ProjectDetailLayout from "./ProjectDetailLayout.vue";
import { ValidationProvider, ValidationObserver, Form } from "vee-validate";
import DatePicker from "vue2-datepicker";
import { mapGetters } from "vuex";
export default {
  components: {
    ProjectDetailLayout,
    ValidationProvider,
    ValidationObserver,
    DatePicker,
    Form,
  },
  data() {
    return {
      show: false,
      newContract: {
        date: "",
        name: "this.account.name",
        document: "",
        timeSheet: "",
      },
      fileError: false,
    };
  },
  created() {},
  computed: {
    ...mapGetters({
      historyContract: "projectManagement/historyContract",
      account: "auth/account",
    }),
    indexContact() {
      return 5;
    },
  },
  methods: {
    async openModal() {
      await this.$bvModal.show("modal-history");
    },
    async handleFileChange(e) {
      const { valid } = await this.$refs.provider.validate(e);

      if (valid) {
        // TODO: Upload the file
        console.log("Uploaded the file...");
      }
    },
    async onSubmit(e) {
      const { valid } = await this.$refs.provider.validate(e);
      this.fileError = valid ? true : false;
      if (valid) {
        // TODO: Upload the file
        console.log("Uploaded the file...", valid);
      }
      console.log("first");
    },
    onChangeFile() {},
  },
};
</script>
<style lang="scss">
.history-project-ctn {
  margin: 0 auto;
  padding: 0 30px;
  .ptable {
    --border: 1px solid #efefef;
    border-radius: 10px;
    border-spacing: 0;
    border-collapse: separate;
    border: var(--border);
    border-top: 0;
    overflow: hidden;

    & th:not(:last-child),
    & td:not(:last-child) {
      border-right: var(--border);
    }

    & > thead > tr:not(:last-child) > th,
    & > thead > tr:not(:last-child) > td,
    & > tbody > tr:not(:last-child) > th,
    & > tbody > tr:not(:last-child) > td,
    & > tfoot > tr:not(:last-child) > th,
    & > tfoot > tr:not(:last-child) > td,
    & > tr:not(:last-child) > td,
    & > tr:not(:last-child) > th,
    & > thead:not(:last-child),
    & > tbody:not(:last-child),
    & > tfoot:not(:last-child) {
      border-bottom: var(--border);
    }

    &__thead {
      padding: 1em;
      background: #3488eb;
      border-radius: 10px 10px 0px 0px;

      th {
        text-align: center;
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        color: #ffffff;
        border-bottom: 0 !important;
        border-right: 1px solid;
      }
    }

    &__tbody {
      padding: 1em;
      td {
        text-align: center;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        color: #303c54;
        border: 1px solid #efefef;
        vertical-align: baseline;
      }
      .manipulation {
        &__group {
          button {
            width: 24px;
            height: 24px;
            border: none;
            padding: 0;
            background: none;
            outline: none;
            &:first-child {
              margin-right: 10px;
            }

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .quotation_documents {
        &__group {
          img {
            margin-right: 10px;
          }
        }
      }
    }

    .ptable_input_wrapper {
      width: 100%;
      position: relative;

      .ptable__input {
        width: 100%;
        height: 40px;
        min-width: 150px;
      }

      .ptable__icon {
        position: absolute;
        right: 5px;
        top: 12px;
      }

      .ptable__percentage {
        position: absolute;
        right: 27px;
        top: 12px;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        text-align: center;
        color: #303c54;
      }
    }
  }

  .btn_group {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 12px;
    button {
      background: none;
      outline: none;
      border: none;
    }
    .btn_img {
      width: 31px;
      height: 31px;
      border: none;
      padding: 0;

      &:first-child {
        margin-right: 10px;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.modal-body {
  .input-wrapper {
    font-family: "Roboto";
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    width: 100%;

    .label {
      font-weight: 600;
      font-size: 14px;
      color: #303c54;
      margin-bottom: 8px;
      .required {
        color: red;
      }
    }

    input:not([type="file"]) {
      background: #ffffff;
      border: 1px solid #cfcfcf;
      border-radius: 5px;
      height: 40px;
      padding: 10px;
      width: 100%;

      &:focus {
        color: #768192;
        background-color: #fff;
        border-color: #958bef;
        outline: 0;
      }
      &:disabled {
        opacity: 0.65;
      }
    }
    .validation_error {
      font-size: 12px;
      color: red;
    }
    .mx-datepicker {
      width: 100%;
      height: 40px;
      input {
        height: 40px;
      }
    }
    label {
      margin-bottom: 0;
      border: 1px solid #ededed;
      background: #f8f8f8;
      padding: 6px 17px;
      border-radius: 20px;
      cursor: pointer;
    }
  }
  .btn_group {
    display: flex;
    justify-content: center;

    button {
      width: 172px;
      height: 49px;
      border: 1px solid #6e7a8b;
      border-radius: 5px;
      font-family: "Helvetica Neue", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      text-align: center;
      margin-left: 10px;
    }
    .confirm-button {
      background: #118fa6;
      color: #ebf3f4;
    }

    .cancel-button {
      background: #ffffff;
      color: #1f2d3d;
    }
  }
}
</style>
